import { getStatusLabel } from "@@/core/libraries/adminFunctions";
import Loading from "@@/core/components/shared/Loading/Loading";
import { BModal, BTable, VBModal } from "bootstrap-vue";
import OrderItems from "@@/core/components/order/OrderItems/OrderItems";
import OrderInvoices from "@@/core/components/order/OrderInvoices/OrderInvoices";
import OrderAddress from "@@/core/components/order/OrderAddress/OrderAddress";
import OrderInfo from "@@/core/components/order/OrderInfo/OrderInfo";
import OrderChangeStatus from "@@/core/components/order/OrderChangeStatus/OrderChangeStatus";

export default {
  name: "OrderDetail",
  components: {
    Loading,
    BTable,
    BModal,
    OrderChangeStatus,
    OrderInfo,
    OrderAddress,
    OrderInvoices,
    OrderItems,
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      url: "admin/orders",
      order: null,
      disabled: false,
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.getOrderDetail(this.$route.params.id);
    }
  },
  methods: {
    getStatusLabel,
    updateOrderStatus() {
      this.$refs.changeOrderStatus.updateOrderStatus();
    },
    getOrderDetail(id) {
      this.$axios.get(`${this.url}/${id}`).then((response) => {
        this.order = response.data.data.order;
      });
    },
  },
};
